
import CheckmarkIcon from '@/components/ui/icons/CheckmarkIcon.vue';

export default {
  name: 'MyFormulateCheckbox',
  components: { CheckmarkIcon },
  props: {
    label: { type: String, required: true },
    optionId: { type: [String, Number], required: true },
    selectedOptions: { type: Array, required: true },
    multiple: { type: Boolean, default: true },
    // Optional: in single-choice, should clicking the selected one unselect?
    allowEmpty: { type: Boolean, default: false },
  },
  computed: {
    isChecked() {
      return this.selectedOptions.includes(this.optionId);
    },
  },
  methods: {
    toggle() {
      const isChecked = this.isChecked;

      // SINGLE CHOICE
      if (!this.multiple) {
        if (isChecked) {
          this.$emit('onChange', this.allowEmpty ? [] : [this.optionId]);
        } else {
          this.$emit('onChange', [this.optionId]);
        }
        return;
      }

      // MULTIPLE CHOICE (current behavior)
      let options = [...this.selectedOptions];
      if (isChecked) options = options.filter((id) => id !== this.optionId);
      else options.push(this.optionId);

      this.$emit('onChange', options);
    },
  },
};
